"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CogFactory = exports.Cog = void 0;
class CogFactory {
  constructor(scene) {
    this.scene = scene;
  }
  create(obstaclesGroup) {
    const cog = new Cog(this.scene);
    obstaclesGroup.add(cog);
    return cog;
  }
}
exports.CogFactory = CogFactory;
class Cog extends Phaser.Physics.Arcade.Sprite {
  constructor(scene) {
    const x = 0;
    const y = 0;
    super(scene, x, y, "cog");
    this.scene = scene;
    scene.add.existing(this);
    scene.physics.add.existing(this);
    this.init();
    this.scene.events.on(Phaser.Scenes.Events.UPDATE, this.update, this);
  }
  init() {
    this.setOrigin(0, 1).setCollideWorldBounds(true).setBodySize(180, 180).setOffset(-15, 30).setDepth(2);

    // Handle resizing
    this.scene.scale.on('resize', this.scaleToFit, this);
    this.scene.scale.on('resize', this.positionOnSky, this);
    this.scaleToFit();
    this.positionOnSky();
  }
  positionOnSky() {
    var _this$scene$sky, _this$scene$sky2;
    const gameHeight = this.scene.scale.height;
    const possibleHeight = [80 * (((_this$scene$sky = this.scene.sky) === null || _this$scene$sky === void 0 ? void 0 : _this$scene$sky.scaleFactors.height) || 1), 170 * (((_this$scene$sky2 = this.scene.sky) === null || _this$scene$sky2 === void 0 ? void 0 : _this$scene$sky2.scaleFactors.height) || 1)];
    const cogHeight = possibleHeight[Math.floor(Math.random() * 2)];

    // Position Cog at the bottom of the scaled background
    const skyHeight = this.scene.scale.height;
    const y = gameHeight - (gameHeight - skyHeight) - cogHeight; // Slight offset for alignment
    this.setY(y - 10);
    const distance = Phaser.Math.Between(this.scene.scale.width, this.scene.scale.width * 1.8);
    this.setX(distance);
  }
  scaleToFit() {
    var _this$scene$sky3;
    // Use the scale factor from the Sky class to maintain consistency
    const scaleFactor = ((_this$scene$sky3 = this.scene.sky) === null || _this$scene$sky3 === void 0 ? void 0 : _this$scene$sky3.scaleFactors.height) || 1;
    const width = 85;
    const height = 85;

    // Apply the scale factor to the Cog
    this.setDisplaySize(width * scaleFactor, height * scaleFactor);
  }
  update() {}
}
exports.Cog = Cog;